import React, { useState, useEffect,useCallback } from "react";
import "./style.scss";
import moment from "moment";
import { Layout, PageHeader,  Button, Pagination, Input, DatePicker } from "antd";
import OrderCard from "./order-card";
import CateringCard from "./catering-card";
import OrderService from "../../services/OrderService";
import R2Footer from "../../components/Footer";
import { SearchOutlined } from "@ant-design/icons";

const { Content } = Layout;

const STATUSOPTION = ["All Orders", "Preparing", "Ready", "Fulfilled", "new", "ontheway"];

const Orders = (props) => {
  const [orders, setOrders] = useState({});
  const [status, setStatus] = useState("Ready");
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [fromDate, setFromDate] = useState(moment().format('DD-MM-YYYY'));
  const [toDate, setToDate] = useState(moment().format('DD-MM-YYYY'));
  const [size, setSize] = useState('week');

  let subMenu = props?.location?.pathname.split("/")[2];

  useEffect(() => {
    getOrders();
  }, []);

  useEffect(() => {
    getOrders();
  }, [status, page, searchText, fromDate, toDate]);

  const getOrders = useCallback(async () => {
    let orderType = null;
    let orderStatus = null;
    if (subMenu === "delivery") {
      orderType = "ONLINE_DELIVERY";
    } else if (subMenu === "takeout") {
      orderType = "ONLINE_TAKEOUT";
    }

    if (status === "Ready") {
      orderStatus = "READY";
    } else if (status === "Preparing") {
      orderStatus = "PREPARING";
    } else if (status === "Fulfilled") {
      orderStatus = "FULFILLED";
    } else if (status === "new") {
      orderStatus = "NEW";
    } else if (status === "ontheway") {
      orderStatus = "ONTHEWAY";
    }

    const data = await OrderService.getOrders(orderStatus, orderType, page, searchText, fromDate, toDate);
    setOrders(data || []);
  },[status, subMenu, page, searchText, fromDate, toDate]);

  const acceptOrder = async (id) => {
    await OrderService.acceptOrder({ order_num: id });
    getOrders();
  };

  const rejectOrder = async (id) => {
    await OrderService.changeOrderStatus({ order_num: id, status: "REJECTED" });
    getOrders();
  };
  const onPageChange = (e) => {
    setPage(e);
  };
  const updateStatus = (optn) => {
    setStatus(optn);
    setPage(1);
    setSearchText("");
  };
  const onChangeExtraTime = async(e, id) => {
    await OrderService.updateTime({ order_num: id, extra_time_mins: e });
    getOrders();
  };
  const onFilterDateChange = (date, dateString, field) => {
    if(field === 'starDate'){
      setFromDate(moment(dateString, 'MMM DD, YYYY'));
    } else {
      setToDate(moment(dateString, 'MMM DD, YYYY'));
    }
    setSize('');
  };
  const onReset = () => {
    setSize('week');
    setFromDate(moment().format('DD-MM-YYYY'));
    setToDate(moment().format('DD-MM-YYYY'));
  };
  return (
    <Layout className="u-page-layout">
      <Content className="w-full">
        <PageHeader className="page-header" title={`Orders`} 
        extra={[
          <>
            <div>
            {/* <div className="flex" style={{ border: size ? "0px" : "2px solid red"}}>
                <div className=""><DatePicker name="starDate" allowClear={false} onChange={(date, dString)=>onFilterDateChange(date, dString, "starDate")} value={moment(fromDate, "DD-MM-YYYY")} format="MMM DD, YYYY" /></div>
                <div className=""><DatePicker name="endDate" allowClear={false} onChange={(date, dString)=>onFilterDateChange(date, dString, 'endDate')} value={moment(toDate, "DD-MM-YYYY")} format="MMM DD, YYYY" /></div>
                <Button type={size ? "dashed" : "primary" } onClick={onReset}>Reset</Button>
              </div> */}
            </div>
            <Input
                prefix={<SearchOutlined style={{ color: "#262626" }} />}
                placeholder="Search"
                size="middle"
                style={{ width: "300px"}}
                value={searchText}
                onChange={(e)=> {
                  setSearchText(e.target.value);
                  setPage(1);
                }}
              />
          </>
        ]}/>
        <div className="text-left mb-1">
          <div className="button-div mb-1 overflow-auto">
            <Button
              className={
                STATUSOPTION[0].includes(status)
                  ? "selected-tab-button"
                  : "button-grp-border default-button"
              }
              onClick={() => updateStatus(STATUSOPTION[0])}
              type="primary"
            >
              All Orders
            </Button>
            <Button
              className={
                STATUSOPTION[4].includes(status)
                  ? "selected-tab-button"
                  : " button-grp-border default-button"
              }
              onClick={() => updateStatus(STATUSOPTION[4])}
              type="primary"
            >
              New Orders
            </Button>
            <Button
              className={
                STATUSOPTION[1].includes(status)
                  ? "selected-tab-button"
                  : " button-grp-border default-button"
              }
              onClick={() => updateStatus(STATUSOPTION[1])}
              type="primary"
            >
              Preparing
            </Button>
            <Button
              className={
                STATUSOPTION[2].includes(status)
                  ? "selected-tab-button"
                  : "button-grp-border default-button"
              }
              onClick={() => updateStatus(STATUSOPTION[2])}
              type="primary"
            >
              Ready
            </Button>
            <Button
              className={
                STATUSOPTION[5].includes(status)
                  ? "selected-tab-button"
                  : "button-grp-border default-button"
              }
              onClick={() => updateStatus(STATUSOPTION[5])}
              type="primary"
            >
              On the Way
            </Button>
            <Button
              className={
                STATUSOPTION[3].includes(status)
                  ? "selected-tab-button"
                  : "button-grp-border default-button"
              }
              onClick={(e) => updateStatus(STATUSOPTION[3])}
              type="primary"
            >
              Fulfilled
            </Button>
          </div>
        </div>
        <div className="mt-2 pt-1">
          {orders?.orders?.map(
            (order) => (
              // isCatering ? (
              //   <CateringCard
              //     key={order.id}
              //     order={order}
              //     updateOrders={getOrders}
              //   />
              // ) : (
              <OrderCard
                key={order.id}
                order={order}
                acceptOrder={acceptOrder}
                rejectOrder={rejectOrder}
                onChangeExtraTime={onChangeExtraTime}
              />
            )
            // )
          )}
        </div>
       {orders?.total > 10 && 
       <div className="text-right">
          <Pagination defaultCurrent={1} showSizeChanger={false} onChange={onPageChange} total={orders?.total} />
       </div>}
      </Content>
      <R2Footer />
    </Layout>
  );
};

export default Orders;
